import { jsx as o, Fragment as w } from "react/jsx-runtime";
import C, { forwardRef as L, useImperativeHandle as N, useEffect as P, useMemo as _ } from "react";
import j from "classnames";
import n from "./index.es5584.js";
import { isString as k } from "lodash";
import { TooltipProvider as E } from "@radix-ui/react-tooltip";
import { useIsToolTippedTextEnabled as F } from "./index.es590.js";
import { SimpleTooltip as M } from "./index.es127.js";
const U = L(
  ({
    type: v,
    size: c,
    variant: p,
    isUnderlined: R,
    isEllipsis: f,
    clamp: a,
    children: r,
    color: s = "primary",
    element: T = "span",
    role: x,
    testId: l,
    highlightText: m,
    className: S,
    ...H
  }, y) => {
    const u = F(), i = C.useRef(), [W, g] = C.useState(!1), z = j(n.text, S, n[`color-${s}`], {
      [n.underlined]: R,
      [n.ellipsis]: f,
      [n[`clamp-${a}`]]: !!a
    });
    N(y, () => i.current, []);
    const b = k(r);
    P(() => {
      if (!b || !u)
        return;
      const e = () => {
        if (!(f || a) || !i.current) {
          g(!1);
          return;
        }
        const t = i.current;
        g(
          t.scrollWidth > t.clientWidth || t.scrollHeight > t.clientHeight
        );
      };
      e();
      const d = new ResizeObserver(e);
      return i.current && d.observe(i.current), () => d.disconnect();
    }, [r, b, f, a, u]);
    const A = _(() => {
      const e = {
        "data-pl-type": v,
        "data-pl-role": x,
        "data-pl-size": c,
        "data-pl-variant": p
      };
      return l && (e["data-testid"] = l), c || delete e["data-pl-size"], p || delete e["data-pl-variant"], e;
    }, [v, x, c, p, l]);
    let h = r;
    if (m && b) {
      const e = m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), d = r.split(new RegExp(`(${e})`, "gi"));
      h = /* @__PURE__ */ o(w, { children: d.map(
        (t, I) => t.toLowerCase() === m.toLowerCase() ? /* @__PURE__ */ o("b", { children: t }, I) : /* @__PURE__ */ o(w, { children: t })
      ) });
    }
    const $ = /* @__PURE__ */ o(
      T,
      {
        color: s,
        ...H,
        ...A,
        className: z,
        ref: i,
        "aria-label": T === "label" ? r : void 0,
        "aria-hidden": s === "disabled",
        "aria-disabled": s === "disabled",
        children: h
      }
    );
    return u ? /* @__PURE__ */ o(E, { children: /* @__PURE__ */ o(
      M,
      {
        title: r,
        testId: `${l}-tooltip`,
        isActive: W,
        zIndex: 1e4,
        maxWidth: 300,
        children: $
      }
    ) }) : $;
  }
);
export {
  U as TextPrimitive
};
//# sourceMappingURL=index.es799.js.map
